import { render, staticRenderFns } from "./Kinapa.vue?vue&type=template&id=b42e83c0&scoped=true&"
import script from "./Kinapa.vue?vue&type=script&lang=js&"
export * from "./Kinapa.vue?vue&type=script&lang=js&"
import style0 from "./Kinapa.vue?vue&type=style&index=0&id=b42e83c0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42e83c0",
  null
  
)

export default component.exports